module.exports = __webpack_public_path__ + "img/Ethiopia.acbd5130.svg";